export default "__VITE_ASSET__Dj4$RJm1__"